import { ICONS } from "../../../assets/icons";
import Tick from "../../../assets/customSVG/Tick";
import Teams from "../../../assets/customSVG/accounts/Teams";

export const overviewData = [
  {
    id: 1,
    label: "Audience",
    icon: Teams,
    height: "10px",
    count: 0,
    data: [],
    toolTip: "Total Audience",
    color: "#B49FF9",
    background: "#B49FF9",
  },
  {
    id: 2,
    label: "Sent",
    icon: Tick,
    count: 0,
    data: [],
    toolTip: "Total number of messages sent",
    color: "#0ACD95",
    background: "#0ACD95",
  },
  {
    id: 3,
    label: "Delivered",
    icon: ICONS?.DeliveredIcon,
    count: 0,
    data: [],
    toolTip: "Total number of messages delivered",
    color: "#F6A723",
  },
  {
    id: 4,
    label: "Read",
    icon: ICONS?.OpenedIcon,
    count: 0,
    data: [],
    toolTip: "Total Read",
    color: "#007AFF",
  },
  {
    id: 5,
    label: "Bounced",
    icon: ICONS?.BouncedIcon,
    count: 0,
    data: [],
    toolTip: "Total Bounced",
    color: "#FF543E",
  },
];

export const performanceData = [
  {
    id: 1,
    label: "Clicks",
    icon: ICONS?.performanceClicks,
    count: 0,
    value: 9,
    color: "#9747FF",
    key: "clicks",
  },
  {
    id: 2,
    label: "Reactions",
    icon: ICONS?.performanceReactions,
    count: 0,
    value: 8,
    color: "#F6A723",
    key: "reactions",
  },
  {
    id: 3,
    label: "Leads",
    icon: ICONS?.performanceLeads,
    count: 0,
    value: 10,
    color: "#3E93FF",
    key: "leads",
  },
  {
    id: 4,
    label: "Opt-out",
    icon: ICONS?.performanceBlcoked,
    count: 0,
    value: 12,
    color: "#FF543E",
    key: "opted_out",
  },
];

export const performanceLeads = [
  {
    id: 1,
    label: "Clicks",
    icon: ICONS?.performanceClicks,
    count: 0,
    value: 9,
    color: "#9747FF",
    key: "clicks",
  },
  {
    id: 2,
    label: "Leads",
    icon: ICONS?.performanceLeads,
    count: 0,
    value: 10,
    color: "#3E93FF",
    key: "leads",
  },
  {
    id: 3,
    label: "Completion",
    icon: ICONS?.leadsGreen,
    count: 0,
    value: 11,
    color: "#00D998",
    key: "completed",
  },
];

export const performanceSales = [
  {
    id: 1,
    label: "Payment Pending",
    icon: ICONS?.delayIcon,
    count: 0,
    value: 5,
    color: "#9747FF",
    key: "payment_pending",
  },
  {
    id: 2,
    label: "Payment Captured",
    icon: ICONS?.resolved,
    count: 0,
    value: 10,
    color: "#3E93FF",
    key: "payment_captured",
  },
  {
    id: 3,
    label: "Payment Failed",
    icon: ICONS?.bouncedOverview,
    count: 0,
    value: -1,
    color: "#00D998",
    key: "payment_failed",
  },
]
